import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import { CgSearch } from 'react-icons/cg';

import './DayPlan.scss';
import MyContext from '../MyContext.jsx';
import FormData from "form-data";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
let GeofencingDistance = 240;


class DayPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      today_schedules : [],
      showing_today_schedules :[],
      visited_schedules : [],
      showing_visited_schedules :[],
      not_visited_schedules : [],
      showing_not_visited_schedules :[],
      upcoming_schedules : [],
      day_pending : [],
      lead_pending : [],
      lead_pending_visited : [],
      routes:[],
      route:[],
      scheduled_route_id : '',
      scheduled_route_ids : [],
      deviation_marked : '',
      currScheduleId : null,
      location : '',
      my_coordinates :  { lat: 23.859073, lng: 57.326585 }, // ALSAFAS OMAN LOCATION
      markers : [],
      distanceMatrix: null,
      isLoaded: false,
      error: "Successfull",
      distances : [],
      durations : [],
      destinations :[],
      markerIndices : [],
      deviationForm : false,
      deviation_remarks : null
    }
    this.formChange = this.formChange.bind(this);
    this.deviationButton = this.deviationButton.bind(this);
    this.closeButtonClose = this.closeButtonClose.bind(this);
    this.deviationRemarksChange = this.deviationRemarksChange.bind(this);
    this.deviationRemarksSubmit = this.deviationRemarksSubmit.bind(this);
    this.calculateDistance = this.calculateDistance.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }
  sortByDistance(schedules){
    schedules = schedules.sort((a, b) => {
      if (a.customerDistance === undefined) {
        return 1; // sort undefined values to last
      } else if (b.customerDistance === undefined) {
        return -1;
      } else {
      
      return a.customerDistance - b.customerDistance;
      }
    });
    return schedules
  }
  
  handleSort(e){
    var obj_this = this
    const buttons = document.querySelectorAll('.bottom_navbar_footer button');
    buttons.forEach((button) => {
      button.classList.remove('active');
    });
    let today_schedules = [... obj_this.state.showing_today_schedules];
    let day_pending =[...obj_this.state.day_pending];
    let lead_pending =[...obj_this.state.lead_pending];
    let not_visited = [...obj_this.state.showing_not_visited_schedules];

    e.target.classList.add('active');
    if(e.target.name==="sortname"){
      today_schedules = today_schedules.sort((a, b) => { return a.customer_name.localeCompare(b.customer_name)});
      day_pending = day_pending.sort((a, b) => { return a.customer_name.localeCompare(b.customer_name)});
      lead_pending = lead_pending.sort((a, b) => { return a.customer_name.localeCompare(b.customer_name)});
      not_visited = not_visited.sort((a, b) => { return a.customer_name.localeCompare(b.customer_name)});
     
    }else if(e.target.name==="sortdistance"){ 
      today_schedules = this.sortByDistance(today_schedules)
      day_pending = this.sortByDistance(day_pending)
      lead_pending = this.sortByDistance(lead_pending)
      not_visited = this.sortByDistance(not_visited)
    }
    obj_this.setState({
      showing_today_schedules : today_schedules,
      day_pending: day_pending,
      lead_pending : lead_pending,
      showing_not_visited_schedules : not_visited
    })
  }
  fetchDayPending(){

    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/dayPlan/getDayPending`;
    obj_this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      if(return_data.status == "success"){
        const day_pending = return_data.day_pending
        const lead_pending = return_data.lead_pending.filter((item) => item.check_inout != "OUT");
        day_pending.sort((a, b) => a.customer_name.localeCompare(b.customer_name));
        lead_pending.sort((a, b) => a.customer.customer_name.localeCompare(b.customer_name));

        day_pending.forEach((item) => {
          if (item.latitude && item.longitude) {
            const customerDistance = obj_this.calculateDistance(obj_this.state.my_coordinates.lat, obj_this.state.my_coordinates.lng, item.latitude, item.longitude);
            item.customerDistance = customerDistance
            if (customerDistance <= GeofencingDistance) {
              item.displayButton = true;
            } else {
              item.displayButton = false;
            }
          }
          else {
            item.displayButton = true;
          }
        });
        lead_pending.forEach((item) => {
          if (item.latitude && item.longitude) {
            const customerDistance = obj_this.calculateDistance(obj_this.state.my_coordinates.lat, obj_this.state.my_coordinates.lng, item.latitude, item.longitude);
            item.customerDistance = customerDistance
            if (customerDistance <= GeofencingDistance) {
              item.displayButton = true;
            } else {
              item.displayButton = false;
            }
          }
          else {
            item.displayButton = true;
          }
        });
        const lead_pending_visited = return_data.lead_pending.filter((item)=>item.check_inout == "OUT");
        // console.log(lead_pending_visited)
        obj_this.setState({
          day_pending: day_pending,
          lead_pending : lead_pending,
          lead_pending_visited : lead_pending_visited,
        });
        // obj_this.context.loading(0);
      }else{
        // obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      // obj_this.context.loading(0);
      alert("Network error");
    });

  }
  attendanceCheck(){
    var obj_this = this;
    const url2=`${process.env.REACT_APP_SSS}/api/getEmployeeAttendance`;
    var newdate=new Date();
    var year=newdate.getFullYear();
    var month=newdate.getMonth()+1;
    var day=newdate.getDate();
    var currdate=`${year}-${month}-${day}`
    $.ajax({
      url:url2,
      data:{
        sid:obj_this.context.user_details.sid,
        date:currdate,
      },
      type:"GET"
    }).done(function(return_data2){
      console.log(return_data2)
      if(return_data2.status=="Unmarked"){
        obj_this.context.setAttendance(false);
        // alert("Please mark your attendance")
        obj_this.setState({
          status : return_data2.status
        });
        obj_this.props.history.replace("/punchin");
      }else if(return_data2.status=="Present"){
        obj_this.context.setAttendance(true);
        if(return_data2.attendance.status){
          obj_this.setState({
            status : return_data2.attendance.status
          });
        }
        // obj_this.props.history.goBack();
      }
    }).fail(function(){
      alert("Network Error");
    });
  }
  
  async componentDidMount(){  
    // this.context.setLocation({
    //   latitude : '',
    //   longitude : ''
    // });  
    var obj_this = this;
    if(obj_this.context.attendance==false){
      obj_this.attendanceCheck();
      // obj_this.props.history.replace("/employee/attendance/leave");
    }
    
    obj_this.fetchData();
    
    // obj_this.context.loading(1);
   
    $(".dayplan_page_container").on("click",".delete_schedule_button",function(){
      if(!confirm("Are you sure you want to delete")){
        return;
      }
      const schedule_id = $(this).attr("schedule_id");
      const url = `${process.env.REACT_APP_SSS}/api/deleteExeSchedule`;
      obj_this.context.loading(1);
      $.ajax({
        url : url,
        data : {
          sid : obj_this.context.user_details.sid,
          schedule_id : schedule_id
        },
        type : "POST"
      }).done(function(return_data){
          // console.log(return_data);
        if(return_data.status == "success"){
          const today_schedules = return_data.schedules.filter((item) => item.date == new Date().toLocaleDateString('en-CA'));
          const upcoming_schedules = return_data.schedules.filter((item) => item.date > new Date().toLocaleDateString('en-CA'));
          obj_this.setState({
            today_schedules: today_schedules,
            upcoming_schedules: upcoming_schedules,
          });
          alert("Schedule deleted")
          obj_this.context.loading(0);
        }else{
          obj_this.context.loading(0);
          obj_this.props.history.replace("/");
        }
      }).fail(function(){
        alert("Network error");
      });

    });


    $(".list_blocks_container").on("click",".check_in_button",function(){
      if(confirm("Confirm check in")){
        const schedule_id = $(this).attr("schedule_id");
        obj_this.props.history.push('dayplan/details/'+schedule_id);
      }
    });
    $(".list_blocks_container").on("click",".lead_check_in_button",function(){
      if(confirm("Confirm check in")){
        const lead_followup_id = $(this).attr("lead_followup_id");
        obj_this.props.history.push('dayplan/lead/details/'+lead_followup_id);
      }
    });
    
  
    ui.swipeMenu(".schedules_container");
  }

  getRoutes(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getExeScheduleRoutes`;
    obj_this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        const selected_route = return_data.selected_route;
        const scheduled_route = return_data.scheduled_route;
        const deviation_marked = return_data.deviation_marked;
        const scheduled_route_ids = scheduled_route.map(x=> x.value);
        obj_this.setState({
          routes: return_data.routes,
          scheduled_route_ids :  scheduled_route_ids,
          deviation_marked : deviation_marked
        });
        if(selected_route){
          obj_this.routeChange(selected_route);
        }
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.context.loading(0);
      alert("Network error");
    });

  }
  fetchData(){
    var obj_this = this;
    if (typeof geo !== 'undefined') {
      geo.getLocation(function(location) {
        if(location && location.latitude) {
            obj_this.context.setLocation(location);
            obj_this.setState({
              my_coordinates: { lat: location.latitude, lng: location.longitude }
            });
        }
    
        var location_coordinates = obj_this.context.location;
        if (location_coordinates.latitude === undefined) {
          setTimeout(async () => {
            await Promise.all([
              obj_this.getRoutes(),
              obj_this.fetchDayPending()
            ]);
          }, 1000);
        } else {
          Promise.all([
            obj_this.getRoutes(),
            obj_this.fetchDayPending()
          ]);
        }
      });
    }else{
      Promise.all([
        obj_this.getRoutes(),
        obj_this.fetchDayPending()
      ]);
    }
  }

  getAllSchedules(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getAllSchedulesForEveryRoute`;
    obj_this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid,
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        var today_schedules= return_data.schedules.filter((item) => item.status == null || item.status == 'APR' );
        today_schedules.sort((a, b) => a.customer_name.localeCompare(b.customer_name));
        var visited_schedules = return_data.schedules.filter((item) => item.status=='CLO');
        visited_schedules.sort((a, b) => a.customer_name.localeCompare(b.customer_name));
        var not_visited_schedules = return_data.schedules.filter((item) =>  item.status ==  null);
        not_visited_schedules.sort((a, b) => a.customer_name.localeCompare(b.customer_name));
        obj_this.setState({
          today_schedules: today_schedules,
          showing_today_schedules : today_schedules,
          visited_schedules : visited_schedules,
          showing_visited_schedules :  visited_schedules,
          not_visited_schedules : not_visited_schedules,
          showing_not_visited_schedules : not_visited_schedules
        });
        let markers =[]
        let markerIndices = []
        // console.log(today_schedules);

        for (let i = 0; i < today_schedules.length; i++) {
          let lat = parseFloat(today_schedules[i].latitude);
          let lng = parseFloat(today_schedules[i].longitude);
        
          if (!isNaN(lat) && !isNaN(lng)) {
            let coord = { lat, lng };
            markers.push(coord);
            markerIndices.push(i);
          }
        }
        // const marker = markers.map(marker => (marker.lat, marker.lng))
        // console.log(markers);
        obj_this.setState({
          markers : markers,
          markerIndices : markerIndices
        })

        // obj_this.getDistanceMatrix()
      
        
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.context.loading(0);
      alert("Network error");
    });

  }
  calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; 
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;
    const distanceInMeters = distance * 1000;
    return distanceInMeters;
  }

  routeChange(option){
    const buttons = document.querySelectorAll('.bottom_navbar_footer button');
    buttons.forEach((button) => {
      button.classList.remove('active');
    });

    this.setState({
      route: option,
    });

    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getSchedulesforRoute`;
    obj_this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid,
        route_id  : option.value
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        var schedules= return_data.schedules;
        schedules.forEach((item)=>{
          if(!obj_this.state.scheduled_route_ids.includes(item.route_id) && obj_this.state.deviation_marked!='Y'){
            item.markDeviation = true;
          }else{
            item.markDeviation = false;
          }
        })
        schedules.forEach((item) => {
          if (item.latitude && item.longitude) {
            const customerDistance = obj_this.calculateDistance(obj_this.state.my_coordinates.lat, obj_this.state.my_coordinates.lng, item.latitude, item.longitude);
            item.customerDistance = customerDistance
            if (customerDistance <= GeofencingDistance) {
              item.displayButton = true;
            } else {
              item.displayButton = false;
            }
          }
          else {
            item.displayButton = true;
          }
        });
        var today_schedules= schedules.filter((item) => item.status == null || item.status =="APR");

        today_schedules.sort((a, b) => a.customer_name.localeCompare(b.customer_name));
        // console.log(today_schedules);
        var visited_schedules = schedules.filter((item) => item.status=='CLO');
        visited_schedules.sort((a, b) => a.customer_name.localeCompare(b.customer_name));
        var not_visited_schedules = schedules.filter((item) =>  item.status ==  null);
        not_visited_schedules.sort((a, b) => a.customer_name.localeCompare(b.customer_name));
        obj_this.setState({
          today_schedules: today_schedules,
          showing_today_schedules : today_schedules,
          visited_schedules : visited_schedules,
          showing_visited_schedules :  visited_schedules,
          not_visited_schedules : not_visited_schedules,
          showing_not_visited_schedules : not_visited_schedules
        });
        let markers =[]
        let markerIndices = []
        // console.log(today_schedules);

        for (let i = 0; i < today_schedules.length; i++) {
          let lat = parseFloat(today_schedules[i].latitude);
          let lng = parseFloat(today_schedules[i].longitude);
        
          if (!isNaN(lat) && !isNaN(lng)) {
            let coord = { lat, lng };
            markers.push(coord);
            markerIndices.push(i);
          }
        }
        // const marker = markers.map(marker => (marker.lat, marker.lng))
        // console.log(markers);
        obj_this.setState({
          markers : markers,
          markerIndices : markerIndices
        })

        // obj_this.getDistanceMatrix();
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.context.loading(0);
      alert("Network error");
    });
    

  }
  formChange(e){
    // console.log(e.target.value);
    var showing_today_schedules =[];
    var showing_visited_schedules=[];
    var showing_not_visited_schedules=[]; 
    if(e.target.value){
      showing_today_schedules = this.state.today_schedules.filter((item) => {return item.customer_name.toLowerCase().includes(e.target.value.toLowerCase())});
      showing_visited_schedules = this.state.visited_schedules.filter((item) => {return item.customer_name.toLowerCase().includes(e.target.value.toLowerCase())});
      showing_not_visited_schedules = this.state.not_visited_schedules.filter((item) => {return item.customer_name.toLowerCase().includes(e.target.value.toLowerCase())});
    }
    else{
      showing_today_schedules = this.state.today_schedules;
      showing_visited_schedules = this.state.visited_schedules;
      showing_not_visited_schedules = this.state.not_visited_schedules;
    }
    // showing_customers = showing_customers.length?showing_customers:this.state.customers;
    this.setState({
      showing_today_schedules : showing_today_schedules,
      showing_visited_schedules : showing_visited_schedules,
      showing_not_visited_schedules : showing_not_visited_schedules
    });
  }
  deviationButton(e){
    const schedule_id = e.currentTarget.getAttribute('schedule_id');
    this.setState({
      deviationForm : true,
      currScheduleId : schedule_id
    })
    
  }
  closeButtonClose(){
    this.setState({
      deviationForm : false
    })
  }
  deviationRemarksChange(e){
    this.setState({
      deviation_remarks : e.target.value
    })
  }

  deviationRemarksSubmit(){
    if(!this.state.deviation_remarks || this.state.deviation_remarks=='')
      return;
    var fd = new FormData()
    fd.append('sid',this.context.user_details.sid);
    fd.append('deviation_remarks',this.state.deviation_remarks);
    fd.append('route_id',this.state.route.value);
    fd.append('scheduled_route_id',this.state.scheduled_route_ids?.[0]);
    const url = `${process.env.REACT_APP_SSS}/api/submitDeviationRemarks`;
    this.context.loading(1);


    axios.post(url,fd).then(result =>{
      if(result.data.status == "success"){
        alert("Deviation Remarks Submitted");
        // if(!confirm("Confirm check in")){
        //   return
        // }
        let schedule_id = this.state.currScheduleId
        if(schedule_id)
          this.props.history.push('dayplan/details/'+schedule_id)
      }
      else if(result.data.status == "already"){
        alert('deviation already marked')
      }
      else if(result.data.status == "failed"){
        alert("Failed")
      }
      this.fetchData()

    }).catch (error=> {
     alert(error)
    });
    

    this.setState({
      deviationForm : false,
      deviation_remarks : null
    })
    this.context.loading(0);

  }

   updateTodaySchedule(distances){
    const distance = distances
    const markerIndices = this.state.markerIndices;
    // console.log(markerIndices);
    let i = -1;
    const updatedTodaySchedules = this.state.today_schedules.map((schedule, index) => {
      if(markerIndices.includes(index))
      {
        i=i+1;
        return {
          ...schedule,
          distance: distance[i], 
        };
       
      } else {
        return schedule; 
      }
    });
    // console.log(updatedTodaySchedules);
    this.setState({ today_schedules: updatedTodaySchedules,
    showing_today_schedules : updatedTodaySchedules});
   } 

  

  render(){


    

  return (
    <MyContext.Consumer>
      {context => (
        <div className="dayplan_page_container noselect">
          <div className="header_spacer"></div>
          <div className="schedules_container uijs swipemenu">
            <div className="page_header">
              <div className="page_title">Day Plan</div>
              {/* <Link className="new_schedule_button" to="/dayplan/new"> 
                <i className="fa fa-plus"></i> New</Link> */}
            </div>
            <div className="toggles_container">
              <div className="list_1 toggles selected" menu="0">
                <i className="fa fa-calendar-alt order_status_icon"></i>
                <div className="order_status">{new Date().toLocaleDateString('en-GB')}</div>
                <div className="order_count">{this.state.today_schedules.length}</div>
              </div>
              <div className="list_2 toggles" menu="1">
                <i className="fa fa-clipboard-check order_status_icon" style={{fontSize: "16px"}}></i>
                <div className="order_status">Day Pending</div>
                <div className="order_count">{this.state.day_pending?.length + this.state.lead_pending?.length}</div>
              </div>
              <div className="list_2 toggles" menu="2">
                <i className="fa fa-clipboard-check order_status_icon" style={{fontSize: "16px"}}></i>
                <div className="order_status">Visited</div>
                <div className="order_count">{this.state.visited_schedules.length + this.state.lead_pending_visited.length}</div>
              </div>
              <div className="list_3 toggles" menu="3">
                <i className="fas fa-suitcase order_status_icon" style={{fontSize: "16px"}}></i>
                <div className="order_status">Not Visited</div>
                <div className="order_count">{this.state.not_visited_schedules.length}</div>
              </div>
              {/* <div className="list_4 toggles" menu="3">
                <i className="fab fa-hive order_status_icon" style={{fontSize: "16px"}}></i>
                <div className="order_status">Upcoming</div>
                <div className="order_count">{this.state.upcoming_schedules.length}</div>
              </div> */}
            </div>
            <div>
              <div className="route_grid">
                <div className="label_route">Route - &nbsp;</div>
                <Select 
                  // styles={{
                  //   menuList: styles => {
                  //   // console.log('menuList:', styles);
                  //   return {
                  //     ...styles,
                  //     maxHeight: 188
                  //   };
                  // }}}
                  options={this.state.routes}  
                  value ={this.state.route}
                  className="route" 
                  // ref={this.branchSelect}
                  isSearchable={false}
                  onChange={e => this.routeChange(e)}
                />  
              </div>
              <div className="search_grid_new_button">
                <div className="search_container">
                    <CgSearch/>
                    <input className="customer_search_input" 
                      placeholder="Search customer.."
                      onChange={this.formChange}
                    />
                </div>
                {/* <Link className="new_schedule_button" to="/customers/new"> 
                  <i className="fa fa-plus"></i> New
                </Link> */}
              </div>
              
            </div>
            <InfiniteScroll
                  dataLength={ this.state.routes.length }
                  refreshFunction={this.fetchData}
                  pullDownToRefresh
                  pullDownToRefreshThreshold={350}
                  pullDownToRefreshContent={
                    <h3 style={{ textAlign: 'center' , top : '50px'}}><i className="fas fa-sync" style={{ animation: 'spin 1s linear infinite' }} aria-hidden="true"></i>
                    </h3>
                  }
                  releaseToRefreshContent={
                    <div className="loading_container" style={{ textAlign: 'center' , top : '100px'}} >
                      <div className="loading_symbol">
                        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                        width="40px" height="40px" viewBox="0 0 50 50" style={{enableBackground:'new 0 0 50 50'}}>
                          <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                             {/*<animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.5s" repeatCount="indefinite"/>*/}
                          </path>
                        </svg>
                      </div>
                    </div>
                  }
                  ></InfiniteScroll>
           
            <div className="list_blocks_container">
              <div className="lists_container">
                
                {this.state.showing_today_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name">
                          <div><i className="fa fa-user"></i> {item.customer_name} </div>
                          {/* <div className="distance"> {item.distance??"N/A"}</div> */}
                        </div>
                        <div className="schedules_info_container">
                          <div className="schedules_leftside_container">
                            <div className="scheduled_address"  style={{display:item.address?"block":"none"}}> 
                              <i className="fas fa-map"></i><span> {item.address}</span> 
                            </div>
                            <div className="scheduled_location_name"  style={{display:item.location_name?"block":"none"}}> 
                              <i className="fas fa-map-marker-alt"></i><span>{item.location_name} - </span> 
                            </div>
                            <div className="identifying_icons" >
                              <div  style={{visibility:item.contact_no?"visible":"hidden"}}>
                                <a className="contact_no"
                                 href={"tel:"+item.contact_no}
                                >
                                <i className="fas fa-phone-alt" aria-hidden="true"></i>
                                </a>
                              </div>
                              <div  style={{visibility:item.latitude?"visible":"hidden"}}>
                                <a className="map_button"
                                 href={"geo:0,0?q="+item.latitude+","+item.longitude+"('"+item.customer_name+"')"}
                                >
                                  <i className="fas fa-map-marker-alt"></i>
                                </a>
                              </div>
                              
                            </div>
                          </div>
                          <div className="schedules_button_container"
                          >
                            { 
                            item.markDeviation && item.displayButton?
                            <div className="deviationButton"
                              schedule_id = {item.id}
                              onClick={this.deviationButton}
                            >Deviation&nbsp;
                              {/* <i className="fas fa-check"></i> */}
                              <i className="fas fa-check-circle"></i>
                            </div>:item.displayButton && item.status == null?
                            <div className="check_in_button" style={{display : item.check_inout == "OUT"?"none":"block"}}
                              schedule_id = {item.id}
                            >Mark Visit&nbsp;
                              {/* <i className="fas fa-check"></i> */}
                              <i className="fas fa-check-circle"></i>
                            </div>:item.displayButton && item.status=="APR"?
                            <Link className="edit_button" style={{display:item.status=='APR'?"block":'none'}}
                              schedule_id = {item.schedule_id}
                              to={"/dayplan/details/edit/"+item.schedule_id}
                            >Check Out&nbsp;
                              <i className="fas fa-check-circle"></i>
                              {/* <i className="fa fa-pencil-alt" style={{fontSize: "14px"}}></i> */}
                            </Link>
                            :<div className="not_applicable_button">{parseFloat(item.customerDistance/1000).toFixed(2)} km away</div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                ))}
                {
                this.state.deviationForm?
                <div className="file_upload_form_ghost">
                  <form className="upload_form">
                    <i className="close_button fas fa-times" onClick={this.closeButtonClose}></i>
                    <div className="input_label">Deviation Remarks</div>
                    <input className="deviation_remarks"
                      type="text"
                      name="remarks"
                      id="remarks"
                      onChange={this.deviationRemarksChange}
                      value={this.state.deviation_remarks}
                      autoComplete="off"
                      required
                    />
                    <button className="confirm_remarks_button" onClick={this.deviationRemarksSubmit}>Submit</button>
                  </form>
                </div>: undefined}
              </div>
              <div className="lists_container">
                {this.state.lead_pending.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                  <div className="scheduled_customer_name_delete_button_container">
                    <div className="customer_name_check_in_button_container">
                      <div className="scheduled_customer_name">
                        <div><i className="fa fa-bullhorn"></i> {item.customer?.customer_name} </div>
                        {/* <div className="distance"> {item.distance??"N/A"}</div> */}
                        <span class="distance">Lead</span>
                      </div>
                      <div className="schedules_info_container">
                        <div className="schedules_leftside_container">
                          <div className="scheduled_address"  style={{display:item.customer?.address?"block":"none"}}> 
                            <i className="fas fa-map"></i><span> {item.customer?.address}</span> 
                          </div>
                          <div className="scheduled_location_name"  style={{display:item.location_name?"block":"none"}}> 
                            <i className="fas fa-map-marker-alt"></i><span>{item.location_name} - </span> 
                          </div>
                          <div className="identifying_icons" >
                            <div  style={{visibility:item.customer?.customer_phone?"visible":"hidden"}}>
                              <a className="contact_no"
                               href={"tel:"+item.customer?.customer_phone}
                              >
                              <i className="fas fa-phone-alt" aria-hidden="true"></i>
                              </a>
                            </div>
                            <div  style={{visibility:item.customer?.latitude?"visible":"hidden"}}>
                              <a className="map_button"
                               href={"geo:0,0?q="+item.customer?.latitude+","+item.customer?.longitude+"('"+item.customer?.customer_name+"')"}
                              >
                                <i className="fas fa-map-marker-alt"></i>
                              </a>
                            </div>
                            
                          </div>
                        </div>
                        <div className="schedules_button_container"
                        >{
                          // item.displayButton?
                          <>
                            <div className="lead_check_in_button" style={{display : item.status == null?"block":"none"}}
                              lead_followup_id = {item.id}
                            >Mark Visit&nbsp;
                              {/* <i className="fas fa-check"></i> */}
                              <i className="fas fa-check-circle"></i>
                            </div>
          
                            <Link className="edit_button" style={{display:item.status=='APR'?"block":'none'}}
                                schedule_id = {item.schedule_id}
                                to={"dayplan/lead/details/edit/"+item.schedule_id}
                              >Check Out&nbsp;
                                <i className="fas fa-check-circle"></i>
                                {/* <i className="fa fa-pencil-alt" style={{fontSize: "14px"}}></i> */}
                            </Link>
                          </>
                          // :
                          // <div className="not_applicable_button">{parseFloat(item.customerDistance/1000).toFixed(2)} km away</div>
                          }
                          
                          <Link className="edit_button" style={{display:item.status=='CLO'?"block":'none',color:"red"}}
                            schedule_id = {item.schedule_id}
                            to={"/dayplan/lead/details/edit/"+item.schedule_id}
                          >Visited&nbsp;
                            <i className="fa fa-eye" style={{fontSize: "14px"}}></i>
                          </Link>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                ))}
               {this.state.lead_pending.length && this.state.day_pending? <hr className="spacer" />:undefined}
                {this.state.day_pending.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name">
                          <div><i className="fa fa-user"></i> {item.customer_name} </div>
                          {/* <div className="distance"> {item.distance??"N/A"}</div> */}
                        </div>
                        <div className="schedules_info_container">
                          <div className="schedules_leftside_container">
                            <div className="scheduled_address"  style={{display:item.address?"block":"none"}}> 
                              <i className="fas fa-map"></i><span> {item.address}</span> 
                            </div>
                            <div className="scheduled_location_name"  style={{display:item.location_name?"block":"none"}}> 
                              <i className="fas fa-map-marker-alt"></i><span>{item.location_name} - </span> 
                            </div>
                            <div className="identifying_icons" >
                              <div  style={{visibility:item.contact_no?"visible":"hidden"}}>
                                <a className="contact_no"
                                 href={"tel:"+item.contact_no}
                                >
                                <i className="fas fa-phone-alt" aria-hidden="true"></i>
                                </a>
                              </div>
                              <div  style={{visibility:item.latitude?"visible":"hidden"}}>
                                <a className="map_button"
                                 href={"geo:0,0?q="+item.latitude+","+item.longitude+"('"+item.customer_name+"')"}
                                >
                                  <i className="fas fa-map-marker-alt"></i>
                                </a>
                              </div>
                              
                            </div>
                          </div>
                          <div className="schedules_button_container"
                          >
                            {item.displayButton?
                            <>
                              <div className="check_in_button" style={{display : item.check_inout == null?"block":"none"}}
                                schedule_id = {item.id}
                              >Mark Visit&nbsp;
                                {/* <i className="fas fa-check"></i> */}
                                <i className="fas fa-check-circle"></i>
                              </div>
                              <Link className="edit_button" style={{ display: item.status == 'APR' ? "block" : 'none' }}
                                schedule_id={item.schedule_id}
                                to={"/dayplan/details/edit/" + item.schedule_id}
                              >Check Out&nbsp;
                                <i className="fas fa-check-circle"></i>
                              </Link>

                            </>
                          :<div className="not_applicable_button">{parseFloat(item.customerDistance/1000).toFixed(2)} km away</div>}
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                ))}
              </div>
              <div className="lists_container">
                {
                  this.state.showing_visited_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name">
                          <div><i className="fa fa-user"></i> {item.customer_name} </div>
                        </div>
                        <div className="schedules_info_container">
                          <div className="schedules_leftside_container">
                            <div className="scheduled_address"  style={{display:item.address?"block":"none"}}> 
                              <i className="fas fa-map"></i><span> {item.address}</span> 
                            </div>
                            <div className="scheduled_location_name"  style={{display:item.location_name?"block":"none"}}> 
                              <i className="fas fa-map-marker-alt"></i><span>{item.location_name}</span> 
                            </div>
                            <div className="identifying_icons" >
                              <div  style={{visibility:item.contact_no?"visible":"hidden"}}>
                                <a className="contact_no"
                                 href={"tel:"+item.contact_no}
                                >
                                <i className="fas fa-phone-alt" aria-hidden="true"></i>
                                </a>
                              </div>
                              <div  style={{visibility:item.latitude?"visible":"hidden"}}>
                                <a className="map_button"
                                 href={"geo:0,0?q="+item.latitude+","+item.longitude+"('"+item.customer_name+"')"}
                                >
                                  <i className="fas fa-map-marker-alt"></i>
                                </a>
                              </div>
                              
                            </div>
                          </div>  
                        <div className="schedules_button_container">
                          {item.displayButton ?
                            <Link className="edit_button" style={{ display: item.status == 'APR' ? "block" : 'none' }}
                              schedule_id={item.schedule_id}
                              to={"/dayplan/details/edit/" + item.schedule_id}
                            >Check Out&nbsp;
                              <i className="fas fa-check-circle"></i>
                              {/* <i className="fa fa-pencil-alt" style={{fontSize: "14px"}}></i> */}
                            </Link>

                            : <>
                              {item.status != 'CLO' ? <div className="not_applicable_button">{parseFloat(item.customerDistance / 1000).toFixed(2)} km away</div> : undefined}
                            </>}

                          <Link className="edit_button" style={{ display: item.status == 'CLO' ? "block" : 'none', color: "red" }}
                            schedule_id={item.schedule_id}
                            to={"/dayplan/details/edit/" + item.schedule_id}
                          >View&nbsp;
                            <i className="fa fa-eye" style={{ fontSize: "14px" }}></i>
                          </Link>
                        </div>
                        </div>
                      </div>
                     
                    </div>
                  </div>

                ))
                }
               {  this.state.lead_pending_visited.length && this.state.showing_visited_schedules.length? <hr className="spacer" />:undefined  }

                {
                this.state.lead_pending_visited.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                  <div className="scheduled_customer_name_delete_button_container">
                    <div className="customer_name_check_in_button_container">
                      <div className="scheduled_customer_name">
                        <div><i className="fa fa-bullhorn"></i> {item.customer?.customer_name}</div>
                        {/* <div className="distance"> {item.distance??"N/A"}</div> */}
                        <span class="distance">Lead</span>
                      </div>
                      <div className="schedules_info_container">
                        <div className="schedules_leftside_container">
                          <div className="scheduled_address"  style={{display:item.customer?.address?"block":"none"}}> 
                            <i className="fas fa-map"></i><span> {item.customer?.address}</span> 
                          </div>
                          <div className="scheduled_location_name"  style={{display:item.location_name?"block":"none"}}> 
                            <i className="fas fa-map-marker-alt"></i><span>{item.location_name} - </span> 
                          </div>
                          <div className="identifying_icons" >
                            <div  style={{visibility:item.customer?.customer_phone?"visible":"hidden"}}>
                              <a className="contact_no"
                               href={"tel:"+item.customer?.customer_phone}
                              >
                              <i className="fas fa-phone-alt" aria-hidden="true"></i>
                              </a>
                            </div>
                            <div  style={{visibility:item.customer?.latitude?"visible":"hidden"}}>
                              <a className="map_button"
                               href={"geo:0,0?q="+item.customer?.latitude+","+item.customer?.longitude+"('"+item.customer?.customer_name+"')"}
                              >
                                <i className="fas fa-map-marker-alt"></i>
                              </a>
                            </div>
                            
                          </div>
                        </div>
                        <div className="schedules_button_container"
                        >
                          
                          <Link className="edit_button" style={{display:item.status=='CLO'?"block":'none',color:"red"}}
                            schedule_id = {item.schedule_id}
                            to={"/dayplan/lead/details/edit/"+item.schedule_id}
                          >View&nbsp;
                            <i className="fa fa-eye" style={{fontSize: "14px"}}></i>
                          </Link>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                ))}
              </div>
              <div className="lists_container">
                {this.state.showing_not_visited_schedules.map((item,idx)=>(
                <div className="single_schedule_container" key={idx}>
                <div className="scheduled_customer_name_delete_button_container">
                  <div className="customer_name_check_in_button_container">
                    <div className="scheduled_customer_name">
                          <div><i className="fa fa-user"></i> {item.customer_name} </div>
                    </div>
                    <div className="schedules_info_container">
                      <div className="schedules_leftside_container">
                        <div className="scheduled_address"  style={{display:item.address?"block":"none"}}> 
                          <i className="fas fa-map"></i><span> {item.address}</span> 
                        </div>
                        <div className="scheduled_location_name"  style={{display:item.location_name?"block":"none"}}> 
                          <i className="fas fa-map-marker-alt"></i><span>{item.location_name}</span> 
                        </div>
                        <div className="identifying_icons" >
                          <div  style={{visibility:item.contact_no?"visible":"hidden"}}>
                            <a className="contact_no"
                             href={"tel:"+item.contact_no}
                            >
                            <i className="fas fa-phone-alt" aria-hidden="true"></i>
                            </a>
                          </div>
                          <div  style={{visibility:item.latitude?"visible":"hidden"}}>
                            <a className="map_button"
                             href={"geo:0,0?q="+item.latitude+","+item.longitude+"('"+item.customer_name+"')"}
                            >
                              <i className="fas fa-map-marker-alt"></i>
                            </a>
                          </div>
                          
                        </div>
                      </div>
                      <div className="schedules_button_container"
                      >
                        { 
                          item.markDeviation && item.displayButton?
                          <div className="deviationButton"
                            schedule_id = {item.id}
                            onClick={this.deviationButton}
                          >Deviation&nbsp;
                            {/* <i className="fas fa-check"></i> */}
                            <i className="fas fa-check-circle"></i>
                          </div>:item.displayButton ?
                          <div className="check_in_button" style={{display : item.check_inout == "OUT"?"none":"block"}}
                            schedule_id = {item.id}
                          >Mark Visit&nbsp;
                            {/* <i className="fas fa-check"></i> */}
                            <i className="fas fa-check-circle"></i>
                          </div>:<div className="not_applicable_button">{parseFloat(item.customerDistance/1000).toFixed(2)} km away</div>

                        }
                       
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
                ))}
              </div>
              {/* <div className="lists_container">
                {this.state.upcoming_schedules.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="scheduled_date_container">
                        <div className="scheduled_month">{new Date(item.date).toLocaleString('default', { month: 'short' })}</div>
                        <div className="scheduled_day">{new Date(item.date).getDate()}</div>
                      </div>
                      <div className="customer_name_check_in_button_container">
                        <div className="scheduled_customer_name"><i className="fa fa-user"></i> {item.name}</div> */}
                        {/*<div className="schedules_button_container">
                          <div className="check_in_button"
                            schedule_id = {item.schedule_id}
                          >Check in&nbsp;
                            <i className="fas fa-check"></i>
                          </div>
                          <div className="map_button"
                            schedule_id = {item.schedule_id}
                          >Map&nbsp;
                            <i className="fas fa-map-marker-alt"></i>
                          </div>
                        </div>*/}
                      {/* </div>
                      <div className="delete_schedule_button"
                        schedule_id = {item.schedule_id}
                        style={{alignSelf : "center"}}
                      >       
                        <i className="fas fa-trash-alt"></i>
                      </div>
                    </div>
                  </div>
                ))}
              </div> */}

            </div>
            <div className="bottom_navbar_footer">
              <div className="sort"><i className="fa fa-sort" aria-hidden="true"></i></div>
              <div className="sort-options">
                <button onClick={this.handleSort} className="sort-button" name="sortname">Name</button>
                <button onClick={this.handleSort} className="sort-button" name="sortdistance">Distance</button>
              </div>
            </div>

            

          </div>
          {/** bottom spacer removed; global app_content adds bottom padding **/}

        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default DayPlan;
DayPlan.contextType = MyContext;
